"use strict";
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty(exports, "__esModule", { value: true });
exports.getProperties = void 0;
const core_1 = require("@aws-amplify/core");
const getProperties_1 = require("./internal/getProperties");
/**
 * Gets the properties of a file. The properties include S3 system metadata and
 * the user metadata that was provided when uploading the file.
 *
 * @param input - The GetPropertiesInput object.
 * @returns Requested object properties.
 * @throws A {@link S3Exception} when the underlying S3 service returned error.
 * @throws A {@link StorageValidationErrorCode} when API call parameters are invalid.
 */
const getProperties = (input) => {
    return (0, getProperties_1.getProperties)(core_1.Amplify, input);
};
exports.getProperties = getProperties;
